import posthog from 'posthog-js'

export function usePostHog() {
  posthog.init(process.env.VUE_APP_POSTHOG_KEY, {
    api_host: 'https://us.i.posthog.com',
    defaults: '2025-05-24',
  })

  return { posthog }
}